export default "/packs/images/banner-arrow@2x~962e3ec9aa44f12a90f3cec7aba21151.png";